import { render, staticRenderFns } from "./bolt_labels.vue?vue&type=template&id=26fe6f7a&scoped=true&"
import script from "./bolt_labels.vue?vue&type=script&lang=js&"
export * from "./bolt_labels.vue?vue&type=script&lang=js&"
import style0 from "./bolt_labels.vue?vue&type=style&index=0&id=26fe6f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fe6f7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26fe6f7a')) {
      api.createRecord('26fe6f7a', component.options)
    } else {
      api.reload('26fe6f7a', component.options)
    }
    module.hot.accept("./bolt_labels.vue?vue&type=template&id=26fe6f7a&scoped=true&", function () {
      api.rerender('26fe6f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/bolt/location/tabs/bolt_labels.vue"
export default component.exports